export const GET_STATIC_DATA = 'GET_STATIC_DATA';
export const SET_STATIC_DATA = 'SET_STATIC_DATA';
export const SET_COUNTRY_FLAG_DATA = 'SET_COUNTRY_DATA';
export const SET_REGION_COUNTRY_DATA = 'SET_REGION_COUNTRY_DATA';
export const SET_INDUSTRY_SUBINDUSTRY_DATA = 'SET_INDUSTRY_SUBINDUSTRY_DATA';
